import { useLayoutEffect, useState } from 'react';

export const formatWindowSizeForGTM = (windowSize: number[]): string => {
  return `${windowSize[0]}x${windowSize[1]}`;
};

export const useWindowSize = (): number[] => {
  const [size, setSize] = useState([0, 0]);
  useLayoutEffect(() => {
    function updateSize() {
      setSize([window.innerWidth, window.innerHeight]);
    }
    window.addEventListener('resize', updateSize);
    updateSize();
    return () => window.removeEventListener('resize', updateSize);
  }, []);
  return size;
};
